<a
  href="#"
  class="contents-video-link"
  [ngClass]="{'contents-video-link--reduced-paddings': reducedPaddings}"
  (click)="openModal($event)"
  [matTooltip]="config?.message"
  matTooltipPosition="above"
  aria-label="What is Additional Interest?">
  <mat-icon class="video-icon">play_circle_outline</mat-icon>
  <span class="video-text">{{config?.message}}</span>
</a>
